// pkg195 — Import payments under Billing & Accounting (owner only, /admin/accounting/import) — delivered 2026-10-31
// pkg193 — Accounting nav link under Billing & Accounting, next to Trust (view_billing) — delivered 2026-10-31
// pkg174 — consolidated sidebar (D-174a-e): 27 always-visible links → 13 primary links in six collapsible sections (Clients, Billing & Accounting, Discovery, Documents, Calendar, Settings) with secondary links tucked beneath; Clients + Billing open by default, state persisted per browser, the current page's section auto-opens on arrival (and can then be collapsed); routes unchanged; new Payments link — delivered 2026-10-03
// pkg159 — HQ shell sidebar gains the Marketing Emails link (third HQ link) — delivered 2026-08-18
// pkg153 — HQ shell sidebar gains the Onboarding Emails link under LawMighty HQ (D-153a) — delivered 2026-08-18
// pkg148 — MightyAnalyzer™ added to the Discovery nav section directly under MightyDiscovery™ (D-148a): links to the new landing/client-picker route /admin/dashboard/discovery-analysis; gated can('edit_clients') matching the analyzer route's pkg81 gate; showDiscovery gains edit_clients so the section header appears for analyzer-only staff — delivered 2026-08-16
// pkg134 — Terms of Service + Privacy Policy links in the sidebar footer (always visible on every admin page; public pkg84 routes, new tab) — delivered 2026-07-27
// pkg125 — sidebar brand (D-125a, Ryan's hierarchy matching the app drawer): LawMighty wordmark on TOP, firm name under it, portal label beneath. Asset is /lawmighty-wordmark.png (the transparent red-Law PNG from pkg118) served from public/. Renders on the HQ shell too — wordmark above 'LawMighty HQ' is the desired platform signature there — delivered 2026-07-26
// pkg105a — "My Account" link in the sidebar footer (above Sign Out): the admin's identity + signed-in-devices page at /admin/account; no sidebar nav slot on purpose — it's account plumbing, not a workflow page — delivered 2026-07-25
// pkg103 — Document Modules + MightyExchange™ nav links gated on the firm-level modulesEnabled flag from /my-permissions (visibility gate: dark for every firm except gatest + Hanzelik until the workstream is resolved); Content Modules deliberately stays — delivered 2026-07-19
// pkg98a — nav labels now carry ™ (Ryan's rule amendment: the mark is marked at its most prominent use per surface AND in the nav): MightyDiscovery™ + MightyExchange™ — delivered 2026-07-18
// pkg98 — nav link MightyExchange added to the Modules section (plain meaning carried by the page title's tail, per the naming rules) — delivered 2026-07-18
// pkg91a — nav label AI Discovery → MightyDiscovery (the Discovery section header + page subtitle carry the plain-English meaning; ™ lives on the page title, not the nav) — delivered 2026-07-18
// pkg92a — mobile hotfix: at ≤768px (the index.css mobile-topbar breakpoint) the fixed top-right "?" sat ON the ☰ menu button — the help button now tracks the viewport via matchMedia and becomes a bottom-right floating button on mobile (36px, thumb-reachable, collides with nothing); desktop placement unchanged — delivered 2026-07-17
// pkg92 — Help system (D-92b): a fixed "?" button floats top-right over the content area on every admin page, opening the HelpDrawer (search + context-aware articles from /public/help). Hidden on the HQ shell — the operator console needs no tenant help. useLocation feeds the drawer the current pathname for its "For this page" section — delivered 2026-07-17
// pkg85 — "© {year} LawMighty, LLC" line added to the sidebar footer (LawMighty, LLC formed in Tennessee, July 2026; the platform now has a legal owner of record) — delivered 2026-07-15
// pkg79 — standalone HQ shell (D-79-r2): at hq.lawmighty.com (firm.is_hq from the public firm-info payload) the sidebar renders ONLY the LawMighty HQ link — no firm sections at all; every tenant firm's nav is unchanged; backend enforces the same gate regardless — delivered 2026-07-13
// pkg68 — nav reshuffle (D-68f): new CALENDAR section (Firm-Wide Dates moves in, seeding the future calendar home); Emergency Alert moves to TOOLS; SETTINGS gains Firm Billing + Firm Wallet (owner or purchase_billing staff) — delivered 2026-07-12
// pkg67b — "Case Type Modules" nav link removed: every mutation on that page has been tombstoned (410) since Package 12d; case types are managed on Practice Areas & Case Types (D-67b8) — delivered 2026-07-12
// pkg65 — billing states: past-due warning banner; expired-trial paywall replaces the content area (owner → Subscribe, staff → contact owner); listens for the 402 event and pre-checks status on mount (D-65d/e) — delivered 2026-07-11
// pkg52 — "AI Modules" renamed to "Document Modules" across the nav, page titles, back-links, and helper text (D-53b/c); routes unchanged — delivered 2026-07-09
// pkg39 — nav: module links pulled out of Settings into their own "Modules" section (D-39a/b); "Modules" link relabeled "Content Modules" — delivered 2026-07-03
// pkg32 — Emergency Alert banner + "Emergency Alert" settings link (owner-only)
// pkg21 — "AI Modules" nav entry (manage_modules) — delivered 2026-06-11
import React, { useState, useEffect } from 'react';
import { Outlet, NavLink, useNavigate, useLocation } from 'react-router-dom'; // useLocation pkg92
import { useFirmName, useFirmSettings } from '../contexts/FirmSettingsContext'; // useFirmSettings pkg79
import { useAdminAuth, useAdminPortalLabel } from '../contexts/AdminAuthContext';
import { adminApi } from '../utils/adminApi';
import { firmTimeZoneFrom, setActiveFirmTimeZone } from '../utils/firmDate';
import AlertBanner from './AlertBanner';
import HelpDrawer from './HelpDrawer'; // pkg92

export default function AdminLayout() {
  const navigate = useNavigate();
  const location = useLocation(); // pkg92 — drives the drawer's "For this page"
  const [open, setOpen] = useState(false);
  const [helpOpen, setHelpOpen] = useState(false); // pkg92
  const [, setFirmTzTick] = useState(0);

  // Firm settings may carry timezone / time_zone. Payment dates follow it.
  // Missing or invalid values stay on America/New_York.
  useEffect(() => {
    let cancelled = false;
    adminApi.getFirmSettings()
      .then((data) => {
        if (cancelled) return;
        setActiveFirmTimeZone(firmTimeZoneFrom(data));
        setFirmTzTick((n) => n + 1);
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  // pkg92a — the help button's position depends on the mobile-topbar
  // breakpoint (768px, index.css): top-right would sit on the ☰ button, so
  // on mobile it drops to bottom-right. matchMedia keeps it correct across
  // rotation and resize.
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== 'undefined' && window.matchMedia
      ? window.matchMedia('(max-width: 768px)').matches
      : false
  );
  useEffect(() => {
    if (!window.matchMedia) return undefined;
    const mq = window.matchMedia('(max-width: 768px)');
    const onChange = (e) => setIsMobile(e.matches);
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else mq.addListener(onChange); // older Safari
    return () => {
      if (mq.removeEventListener) mq.removeEventListener('change', onChange);
      else mq.removeListener(onChange);
    };
  }, []);
  const firmName = useFirmName();
  const { firm } = useFirmSettings(); // pkg79 — firm.is_hq selects the standalone HQ shell
  const { adminUser, logout } = useAdminAuth();
  const portalLabel = useAdminPortalLabel();

  // Effective permissions for the currently signed-in admin. While loading,
  // we render the sidebar with no menu items rather than flashing the full
  // menu and then collapsing it (which would briefly leak privileged links).
  const [perms, setPerms] = useState(null);

  useEffect(() => {
    if (!adminUser) return;
    let cancelled = false;
    adminApi.getMyPermissions()
      .then(data => { if (!cancelled) setPerms(data); })
      .catch(err => {
        // If we can't load perms, treat as empty rather than full access.
        if (!cancelled) setPerms({ role: adminUser.role, permissions: {}, isMasterKey: false });
        console.warn('Could not load admin permissions:', err.message);
      });
    return () => { cancelled = true; };
  }, [adminUser]);

  // pkg65 — firm billing state. Fetched once on mount (GET /status is open to
  // any admin) to drive two things: the past-due warning banner (D-65e) and
  // the expired-trial paywall (D-65d). The 'lm:subscription-required' event —
  // dispatched by adminApi on any 402 — is the catch-all for mid-session
  // expiry. The paywall replaces the CONTENT area only; the sidebar stays so
  // the portal still looks like theirs (everything is saved, just paused).
  const [billing, setBilling] = useState(null);
  const [billingLocked, setBillingLocked] = useState(false);
  const [payErr, setPayErr] = useState('');
  const [payBusy, setPayBusy] = useState(false);

  useEffect(() => {
    if (!adminUser) return;
    let cancelled = false;
    adminApi.getBillingStatus()
      .then(b => { if (!cancelled) { setBilling(b); if (b.locked) setBillingLocked(true); } })
      .catch(() => {}); // banner/paywall just don't render; the 402 event still covers lockout
    return () => { cancelled = true; };
  }, [adminUser]);

  useEffect(() => {
    const onLock = () => setBillingLocked(true);
    window.addEventListener('lm:subscription-required', onLock);
    return () => window.removeEventListener('lm:subscription-required', onLock);
  }, []);

  async function handleSubscribe() {
    setPayErr(''); setPayBusy(true);
    try {
      const { url } = await adminApi.createSubscriptionCheckout();
      window.location.href = url;
    } catch (err) {
      setPayErr(err.message || 'Could not start checkout.');
      setPayBusy(false);
    }
  }

  // Browser tab title: "[Firm] – [Portal]". Restored on unmount so leaving
  // admin doesn't strand a stale title.
  useEffect(() => {
    if (firmName && portalLabel) {
      document.title = `${firmName} – ${portalLabel}`;
    }
    return () => { document.title = firmName || 'Firm Portal'; };
  }, [firmName, portalLabel]);

  function handleNav() { setOpen(false); }

  function handleLogout() {
    logout();
    navigate('/admin');
  }

  // pkg174 — collapsible sections. Persisted per browser; the section that
  // owns the current path is forced open so a deep link never lands in a
  // collapsed sidebar.
  const SECTION_DEFAULTS = { clients: true, billing: true, discovery: false, documents: false, calendar: false, settings: false };
  const [openSections, setOpenSections] = useState(() => {
    try { return { ...SECTION_DEFAULTS, ...(JSON.parse(localStorage.getItem('lm_nav_sections') || '{}')) }; }
    catch (_) { return SECTION_DEFAULTS; }
  });
  const path = location.pathname;
  const SECTION_OF = [
    ['clients',   ['/admin/clients', '/admin/create-client', '/admin/closed-files', '/admin/dashboard/contacts', '/admin/dashboard/conflict-check', '/admin/dashboard/import']],
    ['billing',   ['/admin/dashboard/log-time', '/admin/dashboard/invoices', '/admin/dashboard/payments', '/admin/dashboard/trust', '/admin/accounting']],
    ['discovery', ['/admin/dashboard/ai-discovery', '/admin/dashboard/discovery']],
    ['documents', ['/admin/dashboard/modules', '/admin/dashboard/firm-modules', '/admin/dashboard/exchange']],
    ['calendar',  ['/admin/dashboard/firm-dates']],
    ['settings',  ['/admin/dashboard/firm-settings', '/admin/dashboard/staff', '/admin/dashboard/firm-billing', '/admin/dashboard/firm-wallet', '/admin/dashboard/roles', '/admin/dashboard/practice-areas', '/admin/dashboard/activity-log', '/admin/dashboard/mass-email', '/admin/dashboard/emergency-alert']],
  ];
  const currentSection = (SECTION_OF.find(([, prefixes]) => prefixes.some(pre => path.startsWith(pre))) || [])[0];
  // Auto-open the section you NAVIGATE INTO (deep links never land in a
  // collapsed sidebar), but only on arrival — after that the chevron rules,
  // so collapsing the section you're standing in works.
  useEffect(() => {
    if (!currentSection) return;
    setOpenSections(prev => (prev[currentSection] ? prev : { ...prev, [currentSection]: true }));
  }, [currentSection]);
  const isOpen = (id) => !!openSections[id];
  const toggle = (id) => setOpenSections(prev => {
    const next = { ...prev, [id]: !prev[id] };
    try { localStorage.setItem('lm_nav_sections', JSON.stringify(next)); } catch (_) {}
    return next;
  });

  // Owner / master key bypass — they see everything regardless of perms.
  // Non-owners need an enabled permission for each gated nav link.
  const isOwnerEquivalent = perms?.role === 'owner' || perms?.isMasterKey;
  const can = (key) => {
    if (!perms) return false;            // still loading → hide everything
    if (isOwnerEquivalent) return true;  // owners + master key see all
    return !!perms.permissions?.[key];
  };

  // Sidebar footer: signed-in user's name + role/master-key tag.
  const footerName = adminUser?.name || 'Admin';
  const footerRole = adminUser?.isMasterKey
    ? 'master key'
    : (adminUser?.role || '');

  // Section visibility: render the header only if at least one link inside it
  // would render. Computed once per section so we don't repeat the OR chain.
  const showClients =
    can('view_clients') || can('edit_clients') || can('manage_contacts');

  const showBilling =
    can('edit_billing') || can('view_billing');

  // Discovery is its own section now (was scattered across Tools + Settings).
  // It shows if the user can reach ANY of its links: the Responses workspace
  // (discovery_response) or the two owner-only config screens.
  const showDiscovery =
    can('discovery_response') || can('generate_discovery') ||
    can('edit_clients') /* pkg148 — MightyAnalyzer lives here */ || isOwnerEquivalent;

  const showTools =
    can('run_conflict_check') || can('mass_email') ||
    can('import_clio') || can('manage_contacts');

  // pkg39 — Modules is its own section now (was inside Settings). One
  // permission gates all three links, so the flag is just that permission.
  const showModules = can('manage_modules');

  // pkg103 — the module-workstream visibility gate. Firm-level (rides the
  // /my-permissions response), NOT a permission: while firms.modules_enabled
  // is off, Document Modules + MightyExchange links are gone for everyone at
  // the firm, owners included. Content Modules stays — it's the firm's
  // built-in chooser (pkg67), untouched by the parked workstream. Defaults
  // FALSE while perms load, matching the no-flash posture above.
  const modulesEnabled = !!perms?.modulesEnabled;

  // pkg39 — manage_modules no longer lights up Settings on its own; everything
  // left in Settings is gated by owner-equivalent, manage_staff, or firm_dates.
  const showSettings =
    isOwnerEquivalent || can('manage_staff') || can('firm_dates');

  return (
    <div className="portal-layout">
      <aside className={`sidebar${open ? ' open' : ''}`}>
        <div className="mobile-topbar">
          <span className="mobile-topbar-title">{portalLabel || 'Admin'}</span>
          <button className="mobile-menu-btn" onClick={() => setOpen(o => !o)} aria-label="Menu">
            {open ? '✕' : '☰'}
          </button>
        </div>

        <div className="sidebar-brand">
          {/* pkg125 — platform wordmark above the firm name, mirroring the mobile drawer */}
          <img className="sidebar-wordmark" src="/lawmighty-wordmark.png" alt="LawMighty" />
          <h1>{firmName}</h1>
          <p>{portalLabel || 'Admin'}</p>
        </div>

        <nav className="sidebar-nav" onClick={handleNav}>
          {/* pkg79 (D-79-r2) — the standalone HQ shell: at hq.lawmighty.com
              the sidebar is ONE link. Everything a tenant firm sees lives in
              the else branch, untouched. */}
          {firm?.is_hq ? (<>
            <NavLink to="/admin/dashboard/hq" end>LawMighty HQ</NavLink>
            <NavLink to="/admin/dashboard/hq/emails">Onboarding Emails</NavLink>{/* pkg153 */}
            <NavLink to="/admin/dashboard/hq/marketing">Marketing Emails</NavLink>{/* pkg159 */}
            <NavLink to="/admin/dashboard/hq/exchange">Exchange review</NavLink>
          </>) : (<>
          {/* pkg174 — consolidated nav (D-174a-e). Routes unchanged. Each
              section is collapsible; Clients + Billing default open, the
              rest closed; state persists per browser; the section holding
              the current page auto-opens. Primary links read as before;
              secondary ones sit in a "tucked" row (smaller, one click). */}
          <NavLink to="/admin/dashboard" end>Dashboard</NavLink>
          <div style={navDividerStyle} />

          {showClients && <NavSection id="clients" title="Clients" open={isOpen('clients')} onToggle={toggle}>
            {can('view_clients')    && <NavLink to="/admin/clients">All Clients</NavLink>}
            {can('manage_contacts') && <NavLink to="/admin/dashboard/contacts">Contacts</NavLink>}
            <Tucked>
              {can('edit_clients')       && <NavLink to="/admin/create-client">Create client</NavLink>}
              {can('view_clients')       && <NavLink to="/admin/closed-files">Closed files</NavLink>}
              {can('run_conflict_check') && <NavLink to="/admin/dashboard/conflict-check">Conflict check</NavLink>}
              {can('manage_contacts')    && <NavLink to="/admin/dashboard/import-contacts">Import contacts</NavLink>}
              {can('import_clio')        && <NavLink to="/admin/dashboard/import">Clio import</NavLink>}
            </Tucked>
          </NavSection>}

          {showBilling && <NavSection id="billing" title="Billing &amp; Accounting" open={isOpen('billing')} onToggle={toggle}>
            {can('edit_billing') && <NavLink to="/admin/dashboard/log-time">Time</NavLink>}
            {can('view_billing') && <NavLink to="/admin/dashboard/invoices">Invoices</NavLink>}
            {can('view_billing') && <NavLink to="/admin/dashboard/payments">Payments</NavLink>}{/* pkg174 — firm-wide payments + LawPay links */}
            {can('view_billing') && <NavLink to="/admin/dashboard/trust">Trust</NavLink>}
            {can('view_billing') && <NavLink to="/admin/accounting" end>Accounting</NavLink>}{/* pkg193 */}
            {isOwnerEquivalent && <NavLink to="/admin/accounting/import">Import payments</NavLink>}{/* pkg195 */}
          </NavSection>}

          {showDiscovery && <NavSection id="discovery" title="Discovery" open={isOpen('discovery')} onToggle={toggle}>
            {(can('generate_discovery') || isOwnerEquivalent) && <NavLink to="/admin/dashboard/ai-discovery">MightyDiscovery™</NavLink>}
            {(can('edit_clients') || isOwnerEquivalent) && <NavLink to="/admin/dashboard/discovery-analysis">MightyAnalyzer™</NavLink>}
            {can('discovery_response') && <NavLink to="/admin/dashboard/discovery-responses">Responses</NavLink>}
            {isOwnerEquivalent && <Tucked>
              <NavLink to="/admin/dashboard/discovery-sets">Templates</NavLink>
              <NavLink to="/admin/dashboard/discovery-settings">Discovery settings</NavLink>
            </Tucked>}
          </NavSection>}

          {showModules && <NavSection id="documents" title="Documents" open={isOpen('documents')} onToggle={toggle}>
            <NavLink to="/admin/dashboard/modules">Content Modules</NavLink>
            {modulesEnabled && <NavLink to="/admin/dashboard/firm-modules">Document Modules</NavLink>}
            {modulesEnabled && <NavLink to="/admin/dashboard/exchange">MightyExchange™</NavLink>}
          </NavSection>}

          {can('firm_dates') && <NavSection id="calendar" title="Calendar" open={isOpen('calendar')} onToggle={toggle}>
            <NavLink to="/admin/dashboard/firm-dates">Firm-Wide Dates</NavLink>
          </NavSection>}

          {(showTools || showSettings) && <NavSection id="settings" title="Settings" open={isOpen('settings')} onToggle={toggle}>
            {isOwnerEquivalent   && <NavLink to="/admin/dashboard/firm-settings">Firm Settings</NavLink>}
            {can('manage_staff') && <NavLink to="/admin/dashboard/staff">Staff</NavLink>}
            {(isOwnerEquivalent || can('purchase_billing')) && <NavLink to="/admin/dashboard/firm-billing">Subscription &amp; Credits</NavLink>}
            {can('manage_staff') && <NavLink to="/admin/dashboard/activity-log">Activity Log</NavLink>}
            <Tucked>
              {(isOwnerEquivalent || can('purchase_billing')) && <NavLink to="/admin/dashboard/firm-wallet">Firm wallet</NavLink>}
              {can('manage_staff') && <NavLink to="/admin/dashboard/roles">Roles &amp; permissions</NavLink>}
              {isOwnerEquivalent   && <NavLink to="/admin/dashboard/practice-areas">Practice areas &amp; case types</NavLink>}
              {can('mass_email')   && <NavLink to="/admin/dashboard/mass-email">Mass email</NavLink>}
              {isOwnerEquivalent   && <NavLink to="/admin/dashboard/emergency-alert">Emergency alert</NavLink>}
            </Tucked>
          </NavSection>}
          </>)}
        </nav>

        <div className="sidebar-footer">
          <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.6)', fontFamily: 'Arial, sans-serif', marginBottom: 2 }}>
            {footerName}
          </div>
          {footerRole && (
            <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.4)', fontFamily: 'Arial, sans-serif', marginBottom: 8, textTransform: 'capitalize' }}>
              {footerRole}
            </div>
          )}

          {/* pkg105a — My Account: identity + signed-in devices (self-scoped) */}
          <NavLink
            to="/admin/account"
            style={{ display: 'block', fontSize: 12, color: 'rgba(255,255,255,0.7)', fontFamily: 'Arial, sans-serif', marginBottom: 8, textDecoration: 'underline' }}
          >
            My Account
          </NavLink>
          <button onClick={handleLogout}>Sign Out</button>
          {/* pkg134 — always-available legal links (Ryan: users need Terms &
              Privacy accessible at all times; web-portal parity with mobile
              pkg131). Public pkg84 routes; new tab so the session view stays. */}
          <div style={{ fontSize: 10, fontFamily: 'Arial, sans-serif', marginTop: 8, textAlign: 'center' }}>
            <a href="/terms" target="_blank" rel="noopener noreferrer" style={{ color: 'rgba(255,255,255,0.5)' }}>Terms of Service</a>
            <span style={{ color: 'rgba(255,255,255,0.3)', margin: '0 6px' }}>·</span>
            <a href="/privacy" target="_blank" rel="noopener noreferrer" style={{ color: 'rgba(255,255,255,0.5)' }}>Privacy Policy</a>
          </div>
          {/* pkg85 — platform copyright: LawMighty, LLC (TN) is the entity of record */}
          <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.35)', fontFamily: 'Arial, sans-serif', marginTop: 10, textAlign: 'center' }}>
            © {new Date().getFullYear()} LawMighty, LLC
          </div>
        </div>
      </aside>

      <main className="main-content">
        {/* pkg92 — the Help button: fixed top-right over the content area on
            every admin page (D-92b). Hidden on the HQ shell. */}
        {!firm?.is_hq && (
          <button type="button" onClick={() => setHelpOpen(true)} aria-label="Help" title="Help"
            style={{
              position: 'fixed', zIndex: 1100,
              // pkg92a — mobile: bottom-right FAB (the ☰ topbar owns top-right)
              ...(isMobile
                ? { bottom: 18, right: 16, width: 36, height: 36, fontSize: 17 }
                : { top: 12, right: 14, width: 30, height: 30, fontSize: 15 }),
              borderRadius: '50%',
              border: '1.5px solid #0F1838', color: '#0F1838', background: '#fff',
              fontWeight: 700, lineHeight: 1, cursor: 'pointer',
              boxShadow: '0 2px 8px rgba(15,24,56,0.15)', fontFamily: 'Arial, sans-serif',
            }}>?</button>
        )}
        {!firm?.is_hq && (
          <HelpDrawer open={helpOpen} onClose={() => setHelpOpen(false)} pathname={location.pathname} />
        )}
        <AlertBanner />
        {/* pkg65 — past-due warning (full access continues through Stripe's
            retry window, D-65e). Owners get a fix-it button. */}
        {!billingLocked && billing && billing.subscription_status === 'past_due' && (
          <div style={{
            background: '#fff8e1', color: '#5b4a08', border: '1px solid #f0d68a',
            padding: '10px 14px', borderRadius: 4, marginBottom: 14,
            fontFamily: 'Arial, sans-serif', fontSize: 13,
            display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap',
          }}>
            <span>
              <strong>Payment problem.</strong> Your last LawMighty subscription payment failed.
              We'll retry automatically — please update your card to keep uninterrupted access.
            </span>
            {isOwnerEquivalent && (
              <button type="button" className="btn btn-sm"
                onClick={() => adminApi.openBillingPortal().then(({ url }) => { window.location.href = url; }).catch(() => {})}>
                Update payment method
              </button>
            )}
          </div>
        )}
        {billingLocked ? (
          <div style={{ maxWidth: 560, margin: '48px auto', textAlign: 'center', fontFamily: 'Arial, sans-serif' }}>
            <h1 className="page-title" style={{ marginBottom: 8 }}>
              {isOwnerEquivalent ? 'Your free trial has ended' : 'Portal access is paused'}
            </h1>
            {isOwnerEquivalent ? (
              <>
                <p style={{ fontSize: 14, color: '#555', lineHeight: 1.6 }}>
                  Everything your firm built here is saved and waiting. Subscribe to LawMighty —
                  <strong> $29.99/month, unlimited users</strong> — and you'll pick up exactly where you left off.
                </p>
                {payErr && <div className="alert alert-error">{payErr}</div>}
                <button type="button" className="btn btn-primary" onClick={handleSubscribe} disabled={payBusy}
                  style={{ marginTop: 12 }}>
                  {payBusy ? <><span className="spinner" />Opening checkout…</> : 'Subscribe — $29.99/month'}
                </button>
                <p style={{ fontSize: 12, color: '#888', marginTop: 14 }}>
                  Secure checkout by Stripe. Cancel anytime from Firm Settings.
                </p>
              </>
            ) : (
              <p style={{ fontSize: 14, color: '#555', lineHeight: 1.6 }}>
                Your firm's LawMighty subscription is inactive, so the portal is paused.
                All data is saved. Please contact your firm owner to restore access.
              </p>
            )}
          </div>
        ) : (
          <Outlet />
        )}
      </main>
    </div>
  );
}

// Section header — 0.5 alpha + hairline rule so section boundaries actually
// read against the dark sidebar. Padding tightened ("snug" density) to match
// the tighter link rows in index.css.
// pkg174 — section header is a button (chevron) and the body collapses.
function NavSection({ id, title, open, onToggle, children }) {
  return (
    <div>
      <button type="button" onClick={(e) => { e.stopPropagation(); onToggle(id); }} style={navSectionBtnStyle} aria-expanded={open}>
        <span dangerouslySetInnerHTML={{ __html: title }} />
        <span style={{ fontSize: 10, opacity: 0.7 }}>{open ? '▾' : '▸'}</span>
      </button>
      {open && <div>{children}</div>}
    </div>
  );
}

// pkg174 — secondary links inside a section: smaller, indented, still one click.
function Tucked({ children }) {
  const kids = React.Children.toArray(children).filter(Boolean);
  if (!kids.length) return null;
  return <div className="nav-tucked" style={{ padding: '2px 0 6px' }}>{kids}</div>;
}

const navSectionBtnStyle = {
  width: '100%', background: 'none', border: 'none', cursor: 'pointer', textAlign: 'left',
  display: 'flex', justifyContent: 'space-between', alignItems: 'center',
  fontSize: 10, fontFamily: 'Arial, sans-serif', textTransform: 'uppercase', letterSpacing: '0.08em',
  color: 'rgba(255,255,255,0.55)', padding: '12px 24px 4px', borderBottom: '1px solid rgba(255,255,255,0.08)', marginBottom: 2,
};

const navHeaderStyle = {
  fontSize: 10,
  fontFamily: 'Arial, sans-serif',
  textTransform: 'uppercase',
  letterSpacing: '0.08em',
  color: 'rgba(255,255,255,0.5)',
  padding: '12px 24px 4px',
  borderBottom: '1px solid rgba(255,255,255,0.08)',
  marginBottom: 2,
  pointerEvents: 'none',
};

// Thin separator between Dashboard and the first section.
const navDividerStyle = {
  height: 1,
  background: 'rgba(255,255,255,0.1)',
  margin: '8px 24px 0',
};
